import React, { Component } from 'react';

class Resume extends Component {
  render() {

    if(this.props.data){
      var skillmessage = this.props.data.skillmessage;
      var education = this.props.data.education.map(function(education){
        return <div key={education.school}><h3>{education.school}</h3>
        <p className="info">{education.degree} <span>&bull;</span><em className="date">{education.graduated}</em></p>
        <p>{education.description}</p></div>
      })
      var certifications = this.props.data.certifications.map(function(certifications){
         return <div key={certifications.cert}><h3>{certifications.cert}</h3>
            <p className="info">{certifications.description}</p>
         

            <div key={certifications.cert1}><h3>{certifications.cert1}</h3>
            <p className="info">{certifications.description1}</p>
            </div>

            <div key={certifications.cert2}><h3>{certifications.cert2}</h3>
            <p className="info">{certifications.description2}</p>
            </div>

            <div key={certifications.cert3}><h3>{certifications.cert3}</h3>
            <p className="info">{certifications.description3}</p>
            </div>

            <div key={certifications.cert4}><h3>{certifications.cert4}</h3>
            <p className="info">{certifications.description4}</p>
            </div>

            <div key={certifications.cert5}><h3>{certifications.cert5}</h3>
            <p className="info">{certifications.description5}</p>
            </div>

            <div key={certifications.cert6}><h3>{certifications.cert6}</h3>
            <p className="info">{certifications.description6}</p>
            </div>

            <div key={certifications.cert7}><h3>{certifications.cert7}</h3>
            <p className="info">{certifications.description7}</p>
            </div>

            <div key={certifications.cert8}><h3>{certifications.cert8}</h3>
            <p className="info">{certifications.description8}</p>
            </div>
   
            </div>
      })
      var work = this.props.data.work.map(function(work){
        return <div key={work.company}><h3>{work.company}</h3>
            <p className="info">{work.title}<span>&bull;</span> <em className="date">{work.years}</em></p>
            <p>{work.description}</p>
        </div>
      })
      var skills = this.props.data.skills.map(function(skills){
        var className = 'bar-expand '+skills.name.toLowerCase();
        return <li key={skills.name}><span style={{width:skills.level}}className={className}></span><em>{skills.name}</em></li>
      })
    }

    return (
      <section id="resume">

      <div className="row education">
         <div className="three columns header-col">
            <h1><span>Education</span></h1>
         </div>

         <div className="nine columns main-col">
            <div className="row item">
               <div className="twelve columns">
                 {education}
               </div>
            </div>
         </div>
      </div>

      <div className="row certifications">
         <div className="three columns header-col">
            <h1><span>Certifications</span></h1>
         </div>

         <div className="nine columns main-col">
            <div className="row item">
               <div className="twelve columns">
                 {certifications}
               </div>
            </div>
         </div>
      </div>

      <div className="row work">

         <div className="three columns header-col">
            <h1><span>Work</span></h1>
         </div>

         <div className="nine columns main-col">
          {work}
        </div>
    </div>



      <div className="row skill">

         <div className="three columns header-col">
            <h1><span>Skills</span></h1>
         </div>

         <div className="nine columns main-col">

            <p>{skillmessage}
            </p>

				<div className="bars">
				   <ul className="skills">
					  {skills}
					</ul>
				</div>
			</div>
      </div>
   </section>
    );
  }
}

export default Resume;
